export function setNestedProperty<T>(obj: T, prop: string, value: any): T {
    const props = prop.split(".");
    return updateNestedProperty(obj, props, 0, value);
}

function updateNestedProperty<T>(obj: T, props: string[], index: number, value: any): T {

    const newValue = ((props.length - 1) === index)
        ? value
        : updateNestedProperty((obj as any)[props[index]], props, index + 1, value);

    return { ...(obj as any), [props[index]]: newValue };
}
